// extracted by mini-css-extract-plugin
module.exports = {"app":"app-1cda0442304e3508fbee5c4db32ef884"};